import React from "react"

export default () => {
  //const { author } = 'Sidharth'
  return (
    <div className="footer text-muted text-center" style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
      <span className="m-auto">
        <b>Sidharth Praveenkumar</b> &copy; {new Date().getFullYear()}. Made with&nbsp;
        <span className="heart">&nbsp;❤&nbsp;</span> &&nbsp;
        <a href="https://www.gatsbyjs.org/">Gatsby</a>
      </span>
    </div>
  )
}
